<template>
    <div class="form-group">
      <label v-if="label" class="form-label">
        {{ label }}
        <span v-if="required" class="field-required-mark">*</span>
      </label>
  
      <input
        type="text"
        class="form-control"
        :value="displayValue"
        :placeholder="placeholder"
        :disabled="disabled"
        inputmode="decimal"
        @input="onInput"
        @blur="onBlur"
      />
  
      <span v-if="hasError" class="field-error">
        {{ errorMessage }}
      </span>
    </div>
</template>
<script>
  export default {
    name: 'CurrencyInput',
  
    props: {
      value: {
        type: Number,
        default: null
      },
      label: String,
      placeholder: {
        type: String,
        default: '$ 0,00'
      },
      currency: {
        type: String,
        default: 'COP'
      },
      locale: {
        type: String,
        default: 'es-CO'
      },
      required: Boolean,
      disabled: Boolean,
      hasError: Boolean,
      errorMessage: String,
      decimals: {
        type: Number,
        default: 2
      }
    },
  
    data() {
      return {
        displayValue: '',
        isTyping: false
      }
    },
  
    watch: {
      value: {
        immediate: true,
        handler(val) {
          if (this.isTyping) {
            return
          }
          
          const currentRaw = this.displayValue.replace(/[^\d.,]/g, '').replace(',', '.')
          const currentNumeric = parseFloat(currentRaw)
          if (val === currentNumeric && currentRaw !== '') {
            return
          }
          
          if (val === null || val === undefined || val === '') {
            this.displayValue = ''
          } else {
            this.displayValue = this.format(val)
          }
        }
      }
    },
  
    methods: {
      onInput(e) {
        this.isTyping = true
        
        let raw = e.target.value
  
        if (!raw) {
          this.displayValue = ''
          this.$emit('input', null)
          this.$nextTick(() => {
            this.isTyping = false
          })
          return
        }

        raw = raw.replace(/[^\d.,]/g, '')
  
        const hasComma = raw.includes(',')
        const hasDot = raw.includes('.')
        
        if (hasComma && hasDot) {
          const lastComma = raw.lastIndexOf(',')
          const lastDot = raw.lastIndexOf('.')
          if (lastComma > lastDot) {
            raw = raw.replace(/\./g, '').replace(',', '.')
          } else {
            raw = raw.replace(/,/g, '').replace('.', '.')
          }
        } else if (hasComma) {
          raw = raw.replace(',', '.')
        }
        
        const parts = raw.split('.')
        if (parts.length > 2) {
          raw = parts.slice(0, -1).join('') + '.' + parts[parts.length - 1]
        }
        
        if (parts[1] && parts[1].length > this.decimals) {
          raw = parts[0] + '.' + parts[1].slice(0, this.decimals)
        }
  
        const numeric = parseFloat(raw)
        
        this.$emit('input', isNaN(numeric) ? null : numeric)
        
        this.displayValue = raw
        
        setTimeout(() => {
          this.isTyping = false
        }, 100)
      },
  
      onBlur() {
        if (this.value === null || this.value === undefined) {
          this.displayValue = ''
        } else {
          this.displayValue = this.format(this.value)
        }
      },
  
      format(value) {
        return new Intl.NumberFormat(this.locale, {
          style: 'currency',
          currency: this.currency,
          minimumFractionDigits: this.decimals,
          maximumFractionDigits: this.decimals
        }).format(value)
      }
    }
  }
</script>